module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/dev/um.stamps/src/app/saved-tags/saved-tags.component.html
// module id = ../../../../../src/app/saved-tags/saved-tags.component.html
// module chunks = main